<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-menu ref="start_day_menu" v-model="start_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.start_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.start_day" label="开始日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>开始日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.start_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            first-day-of-week="1"
            @input="() => { $refs.start_day_menu.save(queryForm.start_day); start_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="3" sm="6">
        <v-menu ref="end_day_menu" v-model="end_day_menu" :close-on-content-click="false"
          :return-value.sync="queryForm.end_day" transition="scale-transition" min-width="auto" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="queryForm.end_day" label="结束日期" append-icon="mdi-calendar" readonly v-bind="attrs"
              v-on="on" dense outlined hide-details>
              <template v-slot:label>结束日期</template>
            </v-text-field>
          </template>
          <v-date-picker v-model="queryForm.end_day" no-title value="YYYY-mm-dd" scrollable locale="zh-cn"
            first-day-of-week="1"
            @input="() => { $refs.end_day_menu.save(queryForm.end_day); end_day_menu = false; }"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" sm="9">
        <v-autocomplete v-model="queryForm.postlineids" :items="postlines" multiple label="线路"
          :menu-props="{ bottom: true, offsetY: true }" no-data-text="无" outlined dense hide-details>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="6" sm="3">
        <a-space>
          <v-btn color="primary" tile @click="getdata()">
            查询
          </v-btn>
          <v-btn tile @click="getdata('download')">
            导出
          </v-btn>
        </a-space>
      </v-col>
    </v-row>
    <a-table :columns="columns" :data-source="data" :showHeader="false" bordered size="small" :pagination="false"
      :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 'calc(700px + 50%)' }" />
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
export default {
  name: "OrderCalcWeek",
  data() {
    return {
      locale,
      queryForm: {
        start_day: null,
        end_day: null,
        postlineids: [],
      },
      postlines: [],
      data: [],
      columns: [],
      height: 600,
      start_day_menu: false,
      end_day_menu: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {
  },
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 280;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 280;
    };
  },
  activated() {
    let end_day = this.$dayjs().subtract(1, 'day').format('YYYY-MM-DD');
    let start_day = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD');
    this.queryForm = {
      start_day,
      end_day,
      postlineids: this.queryForm.postlineids,
    }
    this.getdata();
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybillweek/calc", { ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.postlines = res.data.postlines;
          this.queryForm.postlineids = res.data.postlineids;
          this.makedata(res.data);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makedata({ weekdays: headers, result }) {
      let columns = [];
      for (let i = 0; i < headers.length; i++) {
        let header = headers[i];
        columns.push({
          title: header,
          dataIndex: header,
          align: 'center',
          customRender: (value, record, index) => {
            if (record.index === 1) {
              let count12 = record[`${header}__count12`];
              let count12_1 = record[`${header}__count12_1`];
              let count12_2 = record[`${header}__count12_2`];
              let count30 = record[`${header}__count30`];
              let count30_1 = record[`${header}__count30_1`];
              let count30_2 = record[`${header}__count30_2`];
              return <div>
                <p><span style="color:#4caf50;">12({count12})</span>/<span style="color:#ff5052;">30({count30})</span></p>
                <p><span style="color:#4caf50;">{count12_1}车</span>/<span style="color:#ff5052;">{count30_1}头{count30_2}挂</span></p>
              </div>;
            }
            if (record.index === 0) {
              return {
                children: <div style="font-weight:bold;">
                  <p>{value.line}</p>
                  <p>{value.dd}</p>
                </div>,
                attrs: {
                  colSpan: i === 0 ? 1 : i === 1 ? headers.length - 1 : 0,
                  style: i === 0 ? 'background-color:#ff5052;color:#fff;text-align:center;' : '',
                },
              };
            }
            if (record.index === 2) {
              return <span style="font-weight:bold;">{value}</span>;
            }
            let date = record[`${header}__date`];
            let time = record[`${header}__time`];
            let postroutecontent = record[`${header}__postroutecontent`];
            let vehicle_number = record[`${header}__vehicle_number`];
            let vehicle_gnumber = record[`${header}__vehicle_gnumber`];
            let otype = record[`${header}__otype`];
            let vtype = record[`${header}__vtype`];
            if (time) {
              if (vtype === '12') {
                if (otype === '临调') {
                  return <div>
                    <p style="font-size:10px;">{date}</p>
                    <p>{time}</p>
                    <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                    <p style="font-size:10px;">{vehicle_gnumber}</p>
                  </div>;
                }
                return <div>
                  <p style="font-size:10px;">{date}</p>
                  <p>{time}</p>
                  <p style="font-size:10px;color:#4caf50;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                  <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                  <p style="font-size:10px;">{vehicle_gnumber}</p>
                </div>;
              }
              else if (vtype === '30') {
                if (otype === '临调') {
                  return <div>
                    <p style="font-size:10px;">{date}</p>
                    <p>{time}</p>
                    <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                    <p style="font-size:10px;color:#ff5052;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                    <p style="font-size:10px;">{vehicle_gnumber}</p>
                  </div>;
                }
                return <div>
                  <p style="font-size:10px;">{date}</p>
                  <p>{time}</p>
                  <p style="font-size:10px;color:#ff5052;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                  <p style="font-size:10px;color:#4caf50;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                  <p style="font-size:10px;">{vehicle_gnumber}</p>
                </div>;
              }
              return <div>
                <p style="font-size:10px;">{date}</p>
                <p>{time}</p>
                <p style="font-size:10px;"><span style="font-weight:bold;">{vehicle_number}</span>({vtype})</p>
                <p style="font-size:10px;">{otype}/<span style="color:red;">{postroutecontent}</span></p>
                <p style="font-size:10px;">{vehicle_gnumber}</p>
              </div>;
            }
            return value;
          },
        });
      }
      let data = [];
      for (let ritem of result) {
        let list1 = [];
        let gresult1 = _.groupBy(ritem.result1, "day");
        let length1 = 0;
        let item1 = { index: 1 };
        for (let i = 0; i < headers.length; i++) {
          let header = headers[i];
          let children = gresult1[header] || [];
          length1 = Math.max(length1, children.length);
          let count12 = 0, count12_1 = [], count12_2 = [];
          let count30 = 0, count30_1 = [], count30_2 = [];
          children.forEach(n => {
            if (n.vtype === '12') {
              count12++;
              count12_1.push(n.vehicle_number);
              if (n.vehicle_gnumber) {
                count12_2.push(n.vehicle_gnumber);
              }
            }
            else if (n.vtype === '30') {
              count30++;
              count30_1.push(n.vehicle_number);
              if (n.vehicle_gnumber) {
                count30_2.push(n.vehicle_gnumber);
              }
            }
          });
          item1[`${header}__count12`] = count12;
          item1[`${header}__count12_1`] = _.uniq(count12_1).length;
          item1[`${header}__count12_2`] = _.uniq(count12_2).length;
          item1[`${header}__count30`] = count30;
          item1[`${header}__count30_1`] = _.uniq(count30_1).length;
          item1[`${header}__count30_2`] = _.uniq(count30_2).length;
        }
        list1.push(item1);
        for (let i = 0; i < length1; i++) {
          let item = {};
          for (let j = 0; j < headers.length; j++) {
            let header = headers[j];
            let targets = gresult1[header] || [];
            if (targets.length === 0 || !targets[i]) continue;
            let {
              date,
              time,
              postroutecontent,
              vehicle_number,
              vehicle_gnumber,
              otype,
              vtype,
            } = targets[i];
            item[`${header}__date`] = date;
            item[`${header}__time`] = time;
            item[`${header}__postroutecontent`] = postroutecontent;
            item[`${header}__vehicle_number`] = vehicle_number;
            item[`${header}__vehicle_gnumber`] = vehicle_gnumber;
            item[`${header}__otype`] = otype;
            item[`${header}__vtype`] = vtype;
          }
          list1.push(item);
        }
        let list2 = [];
        let gresult2 = _.groupBy(ritem.result2, "day");
        let length2 = 0;
        let item2 = { index: 1 };
        for (let i = 0; i < headers.length; i++) {
          let header = headers[i];
          let children = gresult2[header] || [];
          length2 = Math.max(length2, children.length);
          let count12 = 0, count12_1 = [], count12_2 = [];
          let count30 = 0, count30_1 = [], count30_2 = [];
          children.forEach(n => {
            if (n.vtype === '12') {
              count12++;
              count12_1.push(n.vehicle_number);
              if (n.vehicle_gnumber) {
                count12_2.push(n.vehicle_gnumber);
              }
            }
            else if (n.vtype === '30') {
              count30++;
              count30_1.push(n.vehicle_number);
              if (n.vehicle_gnumber) {
                count30_2.push(n.vehicle_gnumber);
              }
            }
          });
          item2[`${header}__count12`] = count12;
          item2[`${header}__count12_1`] = _.uniq(count12_1).length;
          item2[`${header}__count12_2`] = _.uniq(count12_2).length;
          item2[`${header}__count30`] = count30;
          item2[`${header}__count30_1`] = _.uniq(count30_1).length;
          item2[`${header}__count30_2`] = _.uniq(count30_2).length;
        }
        list2.push(item2);
        for (let i = 0; i < length2; i++) {
          let item = {};
          for (let j = 0; j < headers.length; j++) {
            let header = headers[j];
            let targets = gresult2[header] || [];
            if (targets.length === 0 || !targets[i]) continue;
            let {
              date,
              time,
              postroutecontent,
              vehicle_number,
              vehicle_gnumber,
              otype,
              vtype,
            } = targets[i];
            item[`${header}__date`] = date;
            item[`${header}__time`] = time;
            item[`${header}__postroutecontent`] = postroutecontent;
            item[`${header}__vehicle_number`] = vehicle_number;
            item[`${header}__vehicle_gnumber`] = vehicle_gnumber;
            item[`${header}__otype`] = otype;
            item[`${header}__vtype`] = vtype;
          }
          list2.push(item);
        }
        data.push(
          headers.reduce((a, b) => ({ ...a, [b]: _.isEmpty(a) ? { line: ritem.line1, dd: ritem.dd1 } : "", index: 0 }), {}),
          headers.reduce((a, b) => ({ ...a, [b]: b, index: 2 }), {}),
          ...list1,
          headers.reduce((a, b) => ({ ...a, [b]: _.isEmpty(a) ? { line: ritem.line2, dd: ritem.dd2 } : "", index: 0 }), {}),
          headers.reduce((a, b) => ({ ...a, [b]: b, index: 2 }), {}),
          ...list2,
        );
      }
      this.data = data;
      this.columns = columns;
    },
  },
};
</script>
<style lang="less" scoped>
// /deep/ .ant-table-header-column {
//   font-size: 12px;
// }

/deep/ .ant-table-row-cell-break-word {
  padding: 0 !important;
}

// /deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-thead>tr>th {
//   padding: 0;
// }

// /deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
//   padding-bottom: 4px;
// }

// /deep/ .ant-table-thead {
//   font-size: 14px !important;
// }

/deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
  padding: 6px 8px;
  padding-left: 30px;
}

/deep/ p {
  margin: 0;
  padding: 0;
}
</style>